import { createSelector } from 'reselect';

export const getProducts = (state) => state.product.items;
const getItem = (state, props) => props.item;
const getUrl = (state, props) => props.match.url;
export const getSearch = (state, props) => props.match.params.search;
const normalizeSearch = (str) => (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export const productsUrlSelector = createSelector([getUrl], (url) => url);

export const searchProductsSelector = createSelector([getProducts, getSearch],
  (products = [], search) => {
    let decodedSearch = search || '';
    try {
      decodedSearch = decodeURIComponent(decodedSearch);
    } catch (error) {
      decodedSearch = search || '';
    }
    const query = normalizeSearch(decodedSearch);
    if (!query) return [];
    return products.filter((product) => {
      const name = normalizeSearch(product?.name);
      const description = normalizeSearch(product?.description);
      const tags = Array.isArray(product?.tags)
        && product.tags.some((element) => normalizeSearch(element?.name).includes(query));
      return name.includes(query) || description.includes(query) || tags;
    });
  });

export const productImagesSelector = createSelector([getItem],
  (product) => {
    const images = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i <= 6; i++) {
      const image = product[`image${i}`];
      if (image) {
        images.push(image);
      }
    }
    return images;
  });
